import { gql } from '@apollo/client';

export const ALL_NEWS_QUERY = gql`
  query GetNews($input: GetAllNewsInput!) {
    getAllNews(input: $input) {
      total
      list {
        id
        title
        image
        imageCategory
        ingress
        slug
        published
        officetag
        externalUrl
      }
    }
  }
`;
